import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { LOGIN } from "../Constants";
import { LoginSuccess, LoginFailure } from "../Actions/LoginAction";

function* loginRequest(actions) {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank") };
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/login`,
      {
        email: actions.payload.email,
        password: actions.payload.password,
        bankcode: actions.payload.bankcode,
      },
      { headers: headers }
    );
    if (res.status === 200) {
      if (!sessionStorage.getItem("selectedBank")) sessionStorage.setItem("selectedBank", res.data.data.user[0].bankid);

      sessionStorage.setItem("token", res.data.data.access_token);
      sessionStorage.setItem("tokenVerified", res.data.data.access_token);
      sessionStorage.setItem("tokenType", res.data.data.token_type);
      sessionStorage.setItem("userDetails", JSON.stringify(res.data.data.user));
      yield put(LoginSuccess(res.data));
    } else {
      yield put(LoginFailure(res));
    }
  } catch (e) {
    yield put(LoginFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(LOGIN, loginRequest);
}

export default function* LoginSaga() {
  yield all([actionWatcher()]);
}
